// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"4d1da112","252":"c4129854","728":"8cb07c21","729":"a5951056","771":"a27d99a6","998":"2b65801c"}[chunkId] + ".chunk.js";
};